"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const styles_1 = require("@mui/material/styles");
const colors = tslib_1.__importStar(require("./../colors"));
const createPalette_1 = tslib_1.__importStar(require("./createPalette"));
const { orange, black } = colors;
function createDefaultTheme(options = {}, ...localeObjects) {
    const palette = (0, createPalette_1.default)({
        primary: {
            contrastText: (0, createPalette_1.getContrastText)(black[800], 3),
            dark: black[900],
            light: black[600],
            main: black[800],
        },
        secondary: {
            contrastText: (0, createPalette_1.getContrastText)(orange[800], 3),
            dark: orange[900],
            light: orange[500],
            main: orange[800],
        },
        ...options.palette,
    });
    return (0, styles_1.createTheme)((0, styles_1.adaptV4Theme)({
        ...options,
        props: {
            ...options?.props,
            MuiCheckbox: {
                ...options?.props?.MuiCheckbox,
                color: "secondary",
            },
            MuiRadio: {
                ...options?.props?.MuiRadio,
                color: "secondary",
            },
            MuiSwitch: {
                ...options?.props?.MuiSwitch,
                color: "secondary",
            },
        },
        overrides: {
            // ARGUS-12879: Make tooltips readable by increasing fontSize
            ...options.overrides,
            MuiTooltip: {
                ...options?.overrides?.MuiTooltip,
                tooltip: {
                    fontSize: 14,
                    padding: "8px 16px",
                    ...options?.overrides?.MuiTooltip?.tooltip,
                },
            },
        },
        palette,
    }), ...localeObjects);
}
exports.default = createDefaultTheme;
